import {IEmissionBackingEstimate} from '../../models/EmissionBackingEstimate';

export const FETCH_EMISSION_BACKING_ESTIMATE =
  'FETCH_EMISSION_BACKING_ESTIMATE';
export const FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS =
  'FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS';
export const FETCH_EMISSION_BACKING_ESTIMATE_ERROR =
  'FETCH_EMISSION_BACKING_ESTIMATE_ERROR';

export interface FetchEmissionBackingEstimate {
  type: typeof FETCH_EMISSION_BACKING_ESTIMATE;
}

export interface FetchEmissionBackingEstimateSuccess {
  type: typeof FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS;
  payload: IEmissionBackingEstimate;
}

export interface FetchEmissionBackingEstimateError {
  type: typeof FETCH_EMISSION_BACKING_ESTIMATE_ERROR;
}

export type EmissionBackingEstimateActionTypes =
  | FetchEmissionBackingEstimate
  | FetchEmissionBackingEstimateSuccess
  | FetchEmissionBackingEstimateError;
